import { DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { useRafflePageEditorContext } from '../provider';
import Description from './description';
import CreateMailProvider, { useCreateContext } from './provider';
import { BootstrapDialog, StyledActionContainer, StyledButtonCancel, StyledButtonSave } from './styles.css';
import { useMemo } from 'react';

function DescriptionDialog() {
  return (
    <CreateMailProvider>
      <Component />
    </CreateMailProvider>
  );
}


function Component() {
  const { container, setContainer } = useRafflePageEditorContext();
  const { onSubmit } = useCreateContext();

  const title= useMemo(() => {
    switch(container){
      default:
      case "description": 
        return "Draw Description";
      case "prize": 
        return "Prize Description";
      case "tnc": 
        return "Terms & Conditions";
    }
  },[container]);

  return (
    <BootstrapDialog
      fullWidth
      maxWidth="sm"
      open={Boolean(container)}
      onClose={() => setContainer("")} >
      <DialogTitle sx={{ m: 0, px: 4, pt: 3, borderBottom: 1, borderBottomColor: "#F1F5F9" }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Stack>
          <Description />
        </Stack>
      </DialogContent>
      <DialogActions>
        <StyledActionContainer>
          <StyledButtonCancel variant='outlined' onClick={() => setContainer("")} >CANCEL</StyledButtonCancel>
          <StyledButtonSave
            variant="contained"
            form="game-details-form"
            type="submit"
            onClick={onSubmit}
          >
            SAVE
          </StyledButtonSave>
        </StyledActionContainer>
      </DialogActions>
    </BootstrapDialog>
  );
}

export default DescriptionDialog;